<template>
    <div class="contain">
      <div class="container">
          <div v-for="item in basicData" :key="item.key">
              <div  :class="item.type === 'button' ? 'item1' : 'item'" @click="handleClick(item.type)">
                <div v-if="item.type === 'button'" class="button-item">
                    <div class="basicTitle">{{ item.title }}</div>
                    <div class="enterInto">➱</div>
                </div>
                <div v-else class="menu-item">
                    <div class="title-amount">
                        <div class="title">{{ item.title }}</div>
                        <div class="amount">{{ item.amount }}</div>
                    </div>
                    <div class="progress-info">
                      <div class="progress-bar">
                          <div class="progress-fill" :style="{width: item.comp}"></div>
                      </div>
                      <div class="comp">{{ item.comp }}</div>
                    </div>
                </div>
              </div>
          </div>
      </div>
      <div class="wrapper">
          <div style="display: flex; justify-content: end">
              <SidebarMenu sidebarTitle="基本数据" :menu-list="menuList" :active-menu="activeMenu" @menu-click="handleMenuClick"/>
          </div>
          <div style="width: 80%;">
              <div v-if="active !== 'mapTagManagement'">
                  <div class="weather-content">
                      <sewQIndex :title="currentMenuTitle" v-if="active === 'sewQ'" />
                      <watLvlCtrlIndex :title="currentMenuTitle" v-else-if="active === 'watLvlCtrl'" />
                      <watStaPlaIndex :title="currentMenuTitle" v-else-if="active === 'watStaPla'" />
                      <drainPartIndex :title="currentMenuTitle" v-else-if="active === 'drainPart'" />
                      <floodPtsIndex :title="currentMenuTitle" v-else-if="active === 'floodPts'" />
                      <wwtPlantOpIndex :title="currentMenuTitle" v-else-if="active === 'wwtPlantOp'" />
                      <underSurfGrnIndex :title="currentMenuTitle" v-else-if="active === 'underSurfGrn'" />
                  </div>
              </div>
              <router-view v-else></router-view>
          </div>
      </div>

    </div>
</template>

<script>
import SidebarMenu from "@/components/water-affairs-style/sidebarMenu.vue";
import sewQIndex from "@/views/diagnose/sewQ/index.vue";
import watLvlCtrlIndex from "@/views/diagnose/watLvlCtrl/index.vue";
import watStaPlaIndex from "@/views/diagnose/watStaPla/index.vue";
import drainPartIndex from "@/views/diagnose/drainPart/index.vue";
import floodPtsIndex from "@/views/diagnose/floodPts/index.vue";
import wwtPlantOpIndex from "@/views/diagnose/wwtPlantOp/index.vue";
import underSurfGrnIndex from "@/views/diagnose/underSurfGrn/index.vue";
import {selectDetectionNumList} from "@/views/diagnose/api/diagnose";

export default {
    components: {SidebarMenu,sewQIndex,watLvlCtrlIndex,watStaPlaIndex,drainPartIndex,floodPtsIndex,wwtPlantOpIndex,underSurfGrnIndex},
    data() {
        return {
            basicData: [
                { title: '污水产生量', key: 'sewQ', amount: '0', type: 'menu', comp: '80%' },
                { title: '水位控制', key: 'watLvlCtrl', amount: '0', type: 'menu', comp: '34%' },
                { title: '水体现状与规划', key: 'watStaPla', amount: '0', type: 'menu', comp: '65%' },
                { title: '排水分区', key: 'drainPart', amount: '0', type: 'menu', comp: '56%' },
                { title: '易涝点', key: 'floodPts', amount: '0', type: 'menu', comp: '43%' },
                { title: '污水处理厂运行', key: 'wwtPlantOp', amount: '0', type: 'menu', comp: '20%' },
                { title: '下垫面及绿地', key: 'underSurfGrn', amount: '0', type: 'menu', comp: '30%' },
                { title: '开 始 测 评', key: 'startEval', amount: '', type: 'button' },
            ],
            menuList: [
                { title: '污水产生量', key: 'sewQ', amount: '185', type: 'menu', comp: '80%' },
                { title: '水位控制', key: 'watLvlCtrl', amount: '257', type: 'menu', comp: '34%' },
                { title: '水体现状与规划', key: 'watStaPla', amount: '211', type: 'menu', comp: '65%' },
                { title: '排水分区', key: 'drainPart', amount: '147', type: 'menu', comp: '56%' },
                { title: '易涝点', key: 'floodPts', amount: '168', type: 'menu', comp: '43%' },
                { title: '污水处理厂运行', key: 'wwtPlantOp', amount: '184', type: 'menu', comp: '20%' },
                { title: '下垫面及绿地', key: 'underSurfGrn', amount: '241', type: 'menu', comp: '30%' },
            ],
            active: "sewQ",
            activeMenu: 'sewQ',
        };
    },
    computed: {
        currentMenuTitle() {
            const menu = this.menuList.find(m => m.key === this.activeMenu);
            return menu ? menu.title : '污水产生量';
        },
    },
    mounted() {
        this.$bus.$on('switch-component', (key) => {this.active = key;this.activeMenu = key;});
        this.selectDetectionNumList();
    },
    beforeDestroy() {
        this.$bus.$off('switch-component');
    },
    methods: {
        selectDetectionNumList(){
            selectDetectionNumList({}).then(res => {
                    if (res.list && res.list.length > 0) {
                        const dataMap = res.list.reduce((map, item) => {
                            map[item.typename] = item.datanum;
                            return map;
                        }, {});

                        this.basicData = this.basicData.map(item => {
                            if (item.type === 'menu') {
                                return {
                                    ...item,
                                    amount: dataMap[item.key] || item.amount
                                };
                            }
                            return item;
                        });
                        this.menuList = this.menuList.map(item => ({
                            ...item,
                            amount: dataMap[item.key] || item.amount
                        }));
                    }
            })
        },
        handleMenuClick(menuKey) {
            const menu = this.menuList.find(m => m.key === menuKey);
            if (menu) {
                this.activeMenu = menuKey;
                this.active = menuKey;
            }
        },
        handleClick(type){
            if(type === 'button'){
                this.$router.push('expert-diagnosis-report');
            }
        }
    }
};
</script>

<style scoped>
.contain{
    width: 80%;
    margin:2rem auto;
}
.container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
}
.item {
    background: rgb(14 22 42 / 50%);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 1.5rem;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    color: #adadad;
    margin: 0.5rem;
    height: 12vh;
}

.item::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(0, 255, 150, 0.1) 0%, transparent 70%);
    opacity: 0;
    transition: opacity 0.3s ease;
}
.item:hover {
    transform: translateY(-5px);
    border-color: rgba(0, 255, 150, 0.5);
    box-shadow: 0 10px 30px rgba(0, 255, 150, 0.2);
}

.item:hover::before {
    opacity: 1;
}
.item1 {
    background: linear-gradient(135deg, #00ff96, #00d4ff);
    color: rgb(13 32 61);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 1.5rem;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin: 0.5rem;
    height: 12vh;

    display: flex;
    justify-content: center;
    align-content: center;
}

.item1::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(0, 255, 150, 0.1) 0%, transparent 70%);
    opacity: 0;
    transition: opacity 0.3s ease;
}
.item1:hover {
    transform: translateY(-5px);
    border-color: rgba(0, 255, 150, 0.5);
    box-shadow: 0 10px 30px rgba(0, 255, 150, 0.2);
}

.item1:hover::before {
    opacity: 1;
}
.button-item {
    display: flex;
    justify-content: center;
    align-items: center;
}
.basicTitle{
    font-size: 1.5rem;
    font-weight: bold;
}
.enterInto{
    font-size: 1.5rem;
    font-weight: bold;
    margin-left: 1rem;
}
.menu-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.title-amount {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.title {
    width: 70%;
    font-size: 1.2rem;
    font-weight: bold;
    color: #adadad;
    margin-bottom: 0.25rem;
}
.amount {
    width: 30%;
    text-align: right;
    font-size: 1.2rem;
    color: #00ff96;
}
.comp {
    width: 20%;
    text-align: right;
}
.progress-info{
    width: 100%;
    display: flex;
}
.progress-bar {
    width: 100%;
    height: 8px;
    background: rgba(0, 255, 255, 0.1);
    border-radius: 4px;
    overflow: hidden;
    margin: 0.5rem 0;
}

.progress-fill {
    height: 100%;
    background: linear-gradient(135deg, #00ff96, #00d4ff);
    border-radius: 4px;
    transition: width 1s ease;
    animation: progressFlow 2s ease-in-out infinite;
}

@keyframes progressFlow {
    0%, 100% { box-shadow: 0 0 10px rgba(0, 255, 255, 0.3); }
    50% { box-shadow: 0 0 20px rgba(0, 255, 255, 0.6); }
}

.wrapper{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 2rem;
}

.content-title {
    font-size: 1.8rem;
    font-weight: bold;
    background: linear-gradient(135deg, #fff, #00ff96);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 0.5rem;
}

.content-subtitle {
    color: #64748b;
    font-size: 0.95rem;
}

.weather-content {
    background: rgba(20, 35, 70, 0.5);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 2rem;
    margin-bottom: 1.5rem;
}
</style>